import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, UserSearch } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg, tierRank } from "@/lib/api";
import { pfPath } from "@/lib/peopleFinder";
import { cn } from "@/lib/utils";

// Opens People Finder for this job; saveFirst puts the job in the Tracker so contacts can attach.
export const FindPeopleButton = ({ job, saveFirst, saved, compact, className }) => {
  const nav = useNavigate();
  const { tier } = useAuth();
  const [busy, setBusy] = useState(false);
  const go = async (e) => {
    e.stopPropagation();
    if (tierRank(tier) < 2) { window.dispatchEvent(new CustomEvent("rpopro:upgrade", { detail: { message: "People Finder is an Elite feature", tier: "elite" } })); return; }
    if (saveFirst && !saved) {
      setBusy(true);
      try { await api.post("/applications", { job_id: job.id }); } catch (err) { if (err.response?.status !== 409) { toast.error(errMsg(err)); setBusy(false); return; } }
      setBusy(false);
    }
    nav(pfPath({ company: job.company, job_id: job.id, job_title: job.title }));
  };
  return (
    <button onClick={go} disabled={busy} data-testid={`find-people-${job.id}`}
      className={cn(compact ? "inline-flex items-center gap-1 rounded-full border border-[#D4AF37]/40 px-2 py-0.5 text-[10px] font-medium text-[#F3C649] hover:bg-[#33290D]"
        : "inline-flex h-10 items-center gap-2 rounded-full border border-[#D4AF37]/50 px-4 text-sm text-[#F3C649] hover:bg-[#33290D]", className)}>
      {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <UserSearch className={compact ? "h-3 w-3" : "h-4 w-4"} />}Find people to send your resume to
    </button>
  );
};
